import { DialogSize } from '@thyme/nashville/src/types/dialogs'
import { computed, SetupContext } from 'vue'
import type { TDialogProps } from './types'

/**
 *
 * @param props
 * @param context
 */
export function setup(props: TDialogProps, context: SetupContext) {
  const headerClasses = computed(() => {
    return [props.draggable ? 'cursor-grab' : '']
  })

  const dialogClasses = computed(() => {
    const classes = []

    if (props.warning) {
      classes.push('t-dialog-warning')
    }
    if (!props.blocking) {
      classes.push('shadow-2xl')
    }

    const size = (props.size ?? DialogSize.SM).toString()
    classes.push(`t-dialog-${size}`)

    return classes
  })

  const titleClasses = computed(() => {
    return [`font-${props.warning ? 'bold' : 'normal'}`]
  })

  /**
   * Handle visibility changes from PrimeVue Dialog (open/closing) to sync with caller.
   * @param visible - The new visibility state of the dialog.
   */
  function onVisibleChange(visible: boolean) {
    context.emit('update:visible', visible)
    if (visible) {
      context.emit('open')
    } else {
      context.emit('close')
    }
  }

  return {
    dialogClasses,
    headerClasses,
    titleClasses,
    onVisibleChange,
  }
}
